<div class="modal-dialog modal-dialog-scrollable m-0 scrollable-dialog">
  <form class="kt-form w-webkit-fill-available" [formGroup]="form">
    <div class="modal-content h-100">
      <div class="modal-header">
        <h5 class="modal-title">Extend Leads&nbsp;<i class="fa fa-info-circle ml-1" placement="right" [ngbTooltip]="linkToolTip" tooltipClass="tooltip-class"></i></h5>
        <ng-template #linkToolTip>
          <div class="text-left">
            The extension period will be based on the <b>current date</b> adding on <b>Initial Lead Validity Period (Days)</b> from the lead's respective currency.
          </div>
        </ng-template>
        <span class="modal-x-button" (click)="onCloseDialog()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </span>
      </div>
      <div class="modal-body">
        <div class="col-12 row form-group pr-0">
          <label class="col-4 col-form-label">Telemarketer <span class="text-danger">*</span></label>
          <div class="col-8 p-0" [ngClass]="{'div-disabled': this.data?.leadID !== undefined }">
            <kt-dropdown-wo-lazyload class="dropdown-maxheight col-8" [ngClass]="{'disabled-select': this.data?.leadID !== undefined }" style="padding:0"
              [form] = 'form'
              [dropdownList] = 'telemarketerDropdownList'
              [dropdownSettings] = 'telemarketerDropdownSettings'
              [formName] = "'telemarketer_id'"
              [selectionAttributes] = "'id'"
              [selectedItems] = 'telemarketerSelectedItems'
              (selectedItemsChanged)="onSelectTelemarketer($event)">
            </kt-dropdown-wo-lazyload>
          </div>
        </div>
        <div class="col-12 row form-group pr-0" [ngClass]="{'mb-0': invalidDateRange }">
          <label class="col-12 col-form-label sub_tab_title">Lead Filter</label>
          <label class="col-4 col-form-label">Lead Assigned Date <span class="text-danger">*</span>&nbsp;<i class="fa fa-info-circle ml-1" placement="right" [ngbTooltip]="linkToolTip1" tooltipClass="tooltip-class custom-tooltip"></i></label>
          <ng-template #linkToolTip1>
            <div class="text-left">
              Lead assigned date range of selection must be within <b>31 day(s)</b> only.
            </div>
          </ng-template>
          <div class="col-8 p-0" [ngClass]="{'div-disabled-date': this.data?.leadID !== undefined }">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Please select"
                  (change)="onDateRange($event)" formControlName="defaultDate"
                  [timePicker]="true" [timePickerSeconds]="true"
                  [alwaysShowCalendars]="true" [ranges]="ranges"
                  [showCustomRangeLabel]="true" [locale]="dateTimePickerLocale"
                  [timePicker24Hour]="true" [showDropdowns]="true" (click)="updateDateRange()"
                  ngxDaterangepickerMd/>
              <span class="input-group-append" *ngIf="this.data?.leadID == undefined">
                  <span class="input-group-text pointer-calendar" (click)="onClearDate()">X</span>
              </span>
            </div>
          </div>
        </div>
        <ng-container *ngIf="invalidDateRange">
          <div class="col-12 row form-group p-0 m-0">
            <label class="col-4 col-form-label"></label>
            <div class="col-8 p-0" [ngClass]="{'div-disabled': this.data?.leadID !== undefined }">
              <span class="text-danger fw-500">Date range is exceed 31 days.</span>
            </div>
          </div>
        </ng-container>
        <div class="col-12 row form-group pr-0">
          <label class="col-4 col-form-label">Current Lead Status <span class="text-danger">*</span></label>
          <div class="col-8 p-0" [ngClass]="{'div-disabled': this.data?.leadID !== undefined }">
            <kt-dropdown-wo-lazyload class="dropdown-maxheight col-8" [ngClass]="{'disabled-select': this.data?.leadID !== undefined }" style="padding:0"
              [form] = 'form'
              [dropdownList] = 'statuesDropdownList'
              [dropdownSettings] = 'statuesDropdownSettings'
              [formName] = "'status'"
              [selectionAttributes] = "'id'"
              [selectedItems] = 'statuesSelectedItems'
              (selectedItemsChanged)="onSelectStatus($event)">
            </kt-dropdown-wo-lazyload>
          </div>
        </div>
        <hr style="margin-bottom: 2rem">
        <div class="col-12 row form-group pr-0">
          <label class="col-4 col-form-label">Leads <span class="text-danger">*</span></label>
          <div class="col-8 p-0" [ngClass]="{'div-disabled': this.data?.leadID !== undefined }">
            <kt-dropdown-wo-lazyload class="dropdown-maxheight col-8" style="padding:0"
              [form] = 'form'
              [dropdownList] = 'leadsDropdownList'
              [dropdownSettings] = 'leadsDropdownSettings'
              [formName] = "'lead_ids'"
              [selectionAttributes] = "'id'"
              [selectedItems] = 'leadsSelectedItems'>
            </kt-dropdown-wo-lazyload>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="onCloseDialog()"><i class="fas fa-ban"></i>Close</button>
        <button class="btn btn-primary btn-icon-sm mr-2" (click)="onConfirmation()" type="button" [disabled]="buttonLoading || !form.valid || telemarketerSelectedItems.length == 0 || invalidDateRange"><i [class]="buttonLoading? 'fas fa-circle-notch fa-spin p-0 mr-2' : 'fas fa-save'"></i>{{ 'Submit' }}</button>
      </div>
    </div>
  </form>
</div>
<kt-swal-alert [message]="messages$ | async" [data]="data$ | async" (confirmed)="onSubmit()"></kt-swal-alert>